import { ConnectorType } from '@reown/appkit-core';

import { ContractAbi } from 'web3';
import { ethers } from 'ethers';
import { ContractAddress } from '..';
import i18n from "../../../../i18n.ts";
export class MoonService {
    provider: ethers.providers.Web3Provider;
    contractAddress: ContractAddress;
    walletAddress: ContractAddress;
    abi: ContractAbi;
    signer: ethers.providers.JsonRpcSigner;
    contract: ethers.Contract;

    constructor(contractAddress: ContractAddress, abi: ContractAbi, provider: ConnectorType, walletAddress: ContractAddress) {
        this.abi = abi;
        this.contractAddress = contractAddress;
        this.walletAddress = walletAddress;
        //@ts-ignore
        this.provider = new ethers.providers.Web3Provider(provider);
        this.signer = this.provider.getSigner(this.walletAddress);
        this.contract = new ethers.Contract(this.contractAddress, this.abi, this.signer);
    }

    async getMoonBalance(): Promise<string | null> {
        try {
            const result = (await this.contract.balanceOf(this.walletAddress)) as bigint;

            const balance = ethers.utils.formatEther(result);
            return balance;
        } catch (error) {
            console.log(error);
            return null;
        }
    }

    async allowance(spender: ContractAddress, value: number, setMessage: (msg: string) => void): Promise<boolean> {
        try {
            const result = (await this.contract.allowance(this.walletAddress, spender)) as bigint;

            if (!result) {
                return await this.approve(spender, value, setMessage);
            }

            const balance = ethers.utils.formatEther(result);

            if (Number(balance) >= value) return true;

            const ap = await this.approve(spender, value, setMessage);

            if (ap) return true;

            return false;
        } catch (error) {
            console.log(error);
            return false;
        }
    }

    private async approve(spender: ContractAddress, value: number, setMessage: (msg: string) => void): Promise<boolean> {
        try {
            // const amount = ethers.utils
            // console.log(amount);
            const gasEstimate = await this.contract.estimateGas.approve(spender, BigInt(value) * BigInt(1000000000000000000));

            setMessage(i18n.t('approve_amount', {amount: value.toLocaleString()}));
            const tx = await this.contract.approve(spender, BigInt(value) * BigInt(1000000000000000000), {
                gasLimit: gasEstimate.mul(110).div(100),
            });
            console.log(tx);

            setMessage(i18n.t('got_approve_amount', {amount: value.toLocaleString()}));
            const receipt = await tx.wait();

            console.log(receipt);
            return true;
        } catch (error) {
            console.log(error);
            return false;
        }
    }
}
